import { useEffect, useState } from "react";
import InpService from "../domain/ModelFile/InpService";
import { InpFile } from "@/domain/ModelFile/Inp";

const inpService = new InpService();

export interface InpFilesParams {
  name?: string | null;
  locationId?: number | null;
  requireLocation?: boolean;
  organizationId?: number;
  onlyCompleted?: boolean | null;
}

export default function useInpFiles({
  organizationId,
  page = 1,
  size = 20,
  name = null,
  locationId = null,
  requireLocation = false,
  onlyCompleted = null,
  hasControlKpi = null,
  refreshTrigger = 0,
}: {
  organizationId: number;
  page?: number;
  size?: number;
  name?: string | null;
  locationId?: number | null;
  requireLocation?: boolean;
  onlyCompleted?: boolean | null;
  hasControlKpi?: boolean | null;
  refreshTrigger?: number;
}) {
  const [inpFiles, setInpFiles] = useState<InpFile[]>([]);
  const [pagination, setPagination] = useState({ page, size, totalRows: 0 });
  const [params, setParams] = useState<InpFilesParams>({
    name,
    locationId,
    requireLocation,
    organizationId,
    onlyCompleted,
  });

  useEffect(() => {
    setParams({
      name,
      locationId,
      requireLocation,
      organizationId,
      onlyCompleted,
    });
  }, [name, locationId, requireLocation, organizationId, onlyCompleted]);

  useEffect(() => {
    async function handleGetInpFiles() {
      if (requireLocation && !locationId) return;
      const response = await inpService.getModelFilesByOrganization({
        organizationId,
        page,
        size,
        name,
        locationId,
        onlyCompleted,
        hasControlKpi
      });
      setInpFiles(response.inpFiles);
      setPagination({ page, size, totalRows: response.totalRecords });
    }
    
    void handleGetInpFiles();
  }, [page, size, name, locationId, organizationId, requireLocation, onlyCompleted, hasControlKpi, refreshTrigger]);

  return { inpFiles, pagination, params, setPagination, setParams };
}
